module.exports = __webpack_public_path__ + "img/006.a2dc1794.jpg";